GoogleMapLoaderService = ($window, $q) ->
  load : ->
    deferred = $q.defer()

    #only load 1 time for google map script
    if $window.google
      deferred.resolve()
      return deferred.promise

    # set callback
    $window.onGoogleReady = ->
      #Avoid loading RichMarker on Unit-Test because we are mocking empty object {}
      require("GoogleMapRichMarker") if $window.google.maps
      deferred.resolve()

    # append map script
    scriptTag = document.createElement 'script'
    scriptTag.src = '//maps.googleapis.com/maps/api/js?v=3.exp&callback=onGoogleReady&key=AIzaSyD4aCupnhvS4BcsKP79w0V9PHzynYglFcU&sensor=false&.js'
    document.body.appendChild scriptTag

    deferred.promise

GoogleMapLoaderService.$inject = [
  '$window'
  '$q'
]

module.exports = GoogleMapLoaderService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/map/googlemap-loader-service.coffee